import {
  getData,
  postData,
  convertPageModel
} from './api-base.service'

export const getPositions = () => {
  let result = getData('/Oganization/GetPositions');
  return result;
}

export const savePosition = (data) => {
  return postData('/Oganization/SavePosition', data);
}

export const removePosition = (id) => {
  return getData(`/Oganization/RemovePosition/${id}`);
}

export const saveDepartment = (data) => {
  return postData('/Oganization/SaveDepartment', data);
}

export const removeDepartment = (id) => {
  return getData(`/Oganization/RemoveDepartment/${id}`);
}

export const getPersonnels = (withEmployees) => {
  let result = getData('/Oganization/GetPersonnels', {withEmployees: withEmployees});
  return result;
}

export const savePersonnel = (data) => {
  return postData('/Oganization/SavePersonnel', data);
}

export const removePersonnel = (id) => {
  return getData(`/Oganization/RemovePersonnel/${id}`);
}

export const removePersonnelDepartment = (id) => {
  return getData(`/Oganization/RemovePersonnelDepartment/${id}`);
}

export const getOganization = (searchDate = null) => {
  let data = {
    SearchDateText: searchDate
  };
  return postData('/Oganization/GetOganization', data)
}

export const savePersonnelSaveData = (data) => {
  return postData('/Oganization/SavePersonnelSaveData', data);
}

export const movePersonnelToDepartment = (id, departmentId) => {
  let data = {
    departmentId
  };
  return getData(`/Oganization/MovePersonnelToDepartment/${id}`, data);
}

export const getPersonnelHistoryList = (model) => {
  let data = convertPageModel(model);
  return postData(`/Oganization/GetPersonnelHistoryList`, data);
}


// WEBPACK FOOTER //
// ./src/service/oganization.service.js